import { useState } from 'react';

const Field = ({ label, required, description, apiMapping, helperText, type }) => (
  <div className="mb-6">
    <label className="block font-mono font-bold text-blue-600">
      {label} <span className="text-black">{type}</span>{' '}
      {required && <span className="text-sm text-red-600">*required*</span>}
    </label>
    <p className="text-sm text-gray-600">{description}</p>
    {helperText && <p className="mt-1 text-xs text-blue-500">{helperText}</p>}
  </div>
);

const StylesParams = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="max-w-xl p-4 mx-auto">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="mb-4 button button-primary has-arrow has-arrow-white"
      >
        {isExpanded ? 'Hide Style Params' : 'Show Style Params'}
      </button>

      {isExpanded && (
        <div className="p-6 border border-gray-200 rounded-lg shadow">
          <Field
            label="base"
            description="The base style applied to the input element within the iFrame"
            type="string"
          />
          <Field
            label="focus"
            type="string"
            description="Optional style applied when input element within the iFrame gains focus"
          />
          <Field
            label="error"
            type="string"
            description="Style applied to the input element if a validation failure occurs
"
          />
          <Field
            label="placeholder"
            type="string"
            description="Allows for the styling of the input placeholder text"
          />
        </div>
      )}
    </div>
  );
};

export default StylesParams;
